import axios from 'axios';

const setAxiosConfig = () => {
  /* eslint-disable dot-notation */
  // axios.defaults.headers.common['Authorization'] = token;
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
};
export default setAxiosConfig;
